import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import Header from "./components/Header";
import JobsPage from "./pages/JobsPage";
import AboutPage from "./pages/AboutPage";
import LocationsPage from "./pages/LocationsPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import ApplicationPage from "./pages/ApplicationPage";
import HrLoginPage from "./pages/HrLoginPage";
import HrDashboard from "./pages/HrDashboard";
import TeamsPage from "./pages/TeamsPage";
import BusinessPage from "./pages/BusinessPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
        <Route path="/apply/:jobId" element={<ApplicationPage />} />
        <Route path="/hr" element={<HrLoginPage />} />
        <Route path="/hr-dashboard" element={<HrDashboard />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
    </Router>
  );
}

export default App;